import { useQuery } from '../use-query';
import { chatService } from '../../../services';

export const useChatsQuery = (keys: any = {}) => {
  keys.type = 'SUPER_ADMIN_CLIENT';

  return useQuery(
    ['chats', JSON.stringify(keys)],
    () => {
      return chatService.getAll({ params: { ...keys, notLoading: true } }).then((res) => res.data);
    },
    {
      initialData: { data: [], totalCount: 0 },
      cacheTime: 0,
    },
  );
};

export const useChatQuery = (id = '', enabled = true) => {
  return useQuery(
    ['chat', id],
    () => {
      return chatService.get({ id });
    },
    {
      initialData: { messages: [] },
      enabled: !!id && enabled,
      cacheTime: 0,
    },
  );
};
